import { Injectable } from '@angular/core';
import { ID } from '@datorama/akita';
import { HttpClient, HttpParams } from '@angular/common/http';
import { TreatmentStore } from './treatment.store';
import { Treatment, treatmentFactory } from './treatment.model';
import { Observable } from 'rxjs';
import { LanguageService } from '../../../core/services/language/language.service';
import { SettingsQuery } from '../settings/settings.query';
import { CompanyQuery } from '../company/company.query';
import { UserQuery } from '../user/user.query';
import { ClinicDetailQuery } from '../clinic-detail/clinic-detail.query';
import { ApiService } from 'src/app/core/services/api/api.service';

@Injectable({ providedIn: 'root' })
export class TreatmentService {
    constructor(
        private treatmentStore: TreatmentStore,
        private http: HttpClient,
        private languageService: LanguageService,
        private settingsQuery: SettingsQuery,
        private companyQuery: CompanyQuery,
        private userQuery: UserQuery,
        private clinicDetailQuery: ClinicDetailQuery,
        private apiService: ApiService
    ) {}

    /*---------------------*/
    /** OPERACIONES ENTITY */
    /*---------------------*/

    add(treatment: Treatment) {
        this.treatmentStore.add(treatment);
    }

    update(id, treatment: Partial<Treatment>) {
        this.treatmentStore.update(id, treatment);
    }

    remove(id: ID) {
        this.treatmentStore.remove(id);
    }

    setTreatments(treatments) {
        this.treatmentStore.set(treatments);
    }

    /*---------------*/
    /** LLAMADAS API */
    /*---------------*/

    /**
     * Llamada api para obtener las compras de un usuario para una clínica
     */
    private getTreatmentsApi(
        systemKey: string,
        clientToken: string,
        clinicId: string
    ): Observable<any> {
        let params = new HttpParams();
        params = params.append('SystemKey', systemKey);
        params = params.append('ClientToken', clientToken);
        params = params.append('ClinicID', clinicId);
        params = params.append('Cmd', 'c1061');
        params = params.append('Locale', this.languageService.getLocale());

        return this.apiService.callApi(params);
    }

    /*------------*/
    /** SERVICIOS */
    /*------------*/

    /**
     * Llama a la API para obtener las compras  del usuario que hay logeado en el sistema para la clínica en la que está
     * Después ingresa las citas en Akita
     */
    async getTreatments() {
        const treatmentsData = await this.getTreatmentsApi(
            this.settingsQuery.systemKeyURL,
            this.userQuery.tokenId,
            this.clinicDetailQuery.id
        ).toPromise();
        /**
         * Cargamos las clínicas a la Store
         */
       this.setTreatmentsByApi(treatmentsData.Vouchers);
    }

    /**
     * Crea las compras a partir de una Array y las carga en el Store
     */
    setTreatmentsByApi(treatments) {
        const treatmentsEntities = [];
        treatments.forEach((treatment) => {
            treatmentsEntities.push(treatmentFactory(treatment));
        });
        this.setTreatments(treatmentsEntities);
    }
}
